
import AdminLayout from "@/components/admin/AdminLayout";
import UserManagement from "@/components/admin/users/UserManagement";
import { Users } from "lucide-react";

const AdminUsers = () => {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground flex items-center gap-3">
            <Users className="h-8 w-8" />
            User Management
          </h1>
          <p className="text-muted-foreground mt-1">
            Manage user accounts, roles, and permissions
          </p>
        </div>
        
        <UserManagement />
      </div>
    </AdminLayout>
  );
};

export default AdminUsers;
